module.exports = __webpack_public_path__ + "static/hero-performance-e4db9fd603a6602904a60076547ef7e4.svg";